export default "__VITE_ASSET__24433a2c__"